var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/pro-regular-svg-icons";
import { LoanNickNameWrapper } from "./AddLoanNickName.styles";
import i18n from "../../../strings/i18n";
var AddLoanNickName = function (_a) {
    var id = _a.id, ariaLabel = _a.ariaLabel, nickName = _a.nickName, onClick = _a.onClick, rest = __rest(_a, ["id", "ariaLabel", "nickName", "onClick"]);
    var buttonText = nickName || i18n({ labels: "addNickName" });
    return (_jsx(LoanNickNameWrapper, __assign({}, { id: id, ariaLabel: ariaLabel, buttonText: buttonText, onClick: onClick }, rest, { restIcon: _jsx(FontAwesomeIcon, { icon: faEdit, size: "lg" }), activeIcon: _jsx(FontAwesomeIcon, { icon: faEdit, size: "lg" }), "data-private": true })));
};
export default AddLoanNickName;
//# sourceMappingURL=AddLoanNickName.js.map